import { Component, HostListener, Input, OnInit, ViewChild } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { ApexFill, ApexTooltip, ChartComponent } from "ng-apexcharts";

import {
  ApexNonAxisChartSeries,
  ApexResponsive,
  ApexChart,
  ApexTitleSubtitle,
  ApexLegend
} from "ng-apexcharts";

type ChartOptions = {
  series: ApexNonAxisChartSeries;
  chart: ApexChart;
  responsive: ApexResponsive[];
  labels: any;
  title: ApexTitleSubtitle;
  legend: ApexLegend,
  fill: ApexFill,
  tooltip: ApexTooltip
};

@Component({
  selector: 'lib-simple-dougnhut-chart',
  templateUrl: "./simple-dougnhut-chart.component.html"
})
export class SimpleDougnhutChartComponent implements OnInit {

  @Input() series;
  @Input() labels;
  @Input() colors: any;
  @Input() nombre: any;

  public smallScreen: boolean;
  private readonly _BREAKPOINT_SIZE_SCREEN = 1375;

  @ViewChild("chart") chart: ChartComponent;
  public chartOptions: Partial<ChartOptions>;

  constructor(private readonly _translate: TranslateService) {
    this.smallScreen = window.innerWidth <= this._BREAKPOINT_SIZE_SCREEN ? true : false;
  }

  @HostListener('window:resize')
  onWindowResize() {
      console.log('window:resize');
      this.smallScreen = window.innerWidth <= this._BREAKPOINT_SIZE_SCREEN ? true : false;
      this.drawChart();
  }

  ngOnInit() {
    this.drawChart();
  }

  private drawChart() {
    this.chartOptions = {
      series: this.series,
      chart: {
        type: "donut",
        height: this.smallScreen ? 450 : 560,
        width: this.smallScreen ? 500 : 480,
        redrawOnWindowResize: true,
        animations: {
          enabled: false
        },
        toolbar: {
          show: true,
          offsetX: 0,
          offsetY: 0,
          tools: {
            download: true,
            selection: false,
            zoom: false,
            zoomin: false,
            zoomout: false,
            pan: false
          },
          export: {
            csv: {
              filename: undefined,
              columnDelimiter: ',',
              headerCategory: 'category',
              headerValue: 'value',
              dateFormatter(timestamp) {
                return new Date(timestamp).toDateString();
              }
            },
          },
          autoSelected: 'zoom',
        }
      },
      title: {
        // text: "Nº Etiquetadores / Denominación",
        // align: "center",
        // margin: 10,
        // offsetX: -40,
        // offsetY: 10,
        // floating: false,
        // style: {
        //   fontSize: "1.2em",
        //   fontWeight: undefined,
        //   fontFamily: "semibold",
        //   color: "#184d39"
        // }
      },
      legend: {
        position: "top",
        horizontalAlign: "center",
        width: this.smallScreen ? 340 : 340,
        offsetX: (this.smallScreen ? 50 : 30),
        offsetY: 0,
        labels: {
          colors: this.colors,
          useSeriesColors: false
        },
        markers: {
          fillColors: this.colors
        },
        onItemClick: {
          toggleDataSeries: false
        },
        onItemHover: {
          highlightDataSeries: false
        }
      },
      fill: {
        opacity: 1,
        colors:  this.colors
      },
      tooltip: {
        enabled: true,
        fillSeriesColor: false,
        theme: "light",
        marker: {
          fillColors: this.colors
        },
        y: {
          formatter: (val) => {
            let dataLabel;
            isNaN(+val) ? dataLabel = val.toString() +  + ' ' + this.nombre :
              dataLabel = Number(val).toLocaleString(this._translate.getDefaultLang(), {minimumFractionDigits: 0, maximumFractionDigits: 0}) + ' ' + this.nombre;
            return dataLabel;
          }
        }
      },
      labels: this.labels,
      responsive: [
        {
          breakpoint: 480,
          options: {
            chart: {
              width: 200,
            },
            legend: {
              position: "top",
              horizontalAlign: "center",
              offsetX: 0,
            }
          }
        }
      ]
    };
  }
}